package devxertech.com.models

import kotlinx.serialization.Serializable

@Serializable
data class BlogsData(
    val image: String,
    val date: String,
    val title: String,
    val description: String,
    val category: String,
    val link: String = ""
)